import React from 'react';
import { useTranslation } from 'react-i18next';
import EffectFiveChallenges from './EffectFiveChallenges/EffectFiveChallenges';
import { Header } from './EffectFiveChallenges/EffectFiveChallenges.styles';
import FiveChallengesGroupTemplate from './FiveChallengesGroupTemplate/FiveChallengesGroupTemplate';
import { ResultTableTitle } from './ReportEffectInsights.styles';
import TopAndBottomEffect from './TopAndBottomEffect/TopAndBottomEffect';
import { useReportContext } from '../../../../hooks/useReport';

const ReportEffectInsights = () => {
  const {
    structuredEffectData: { insights, topAndBottom },
  } = useReportContext();
  const { fiveChallenges, ...rest } = insights;
  const { t } = useTranslation();

  if (fiveChallenges) {
    return (
      <ResultTableTitle>
        <EffectFiveChallenges data={fiveChallenges} dotsData={rest} />
        <>
          <Header>{t('report.effect.insights.fiveChallenges')}</Header>
          <FiveChallengesGroupTemplate data={rest} />
        </>
        <TopAndBottomEffect data={topAndBottom} />
      </ResultTableTitle>
    );
  } else {
    return null;
  }
};

export default ReportEffectInsights;
